export default __webpack_public_path__ + "static/buyer-report-bottom-d-b9a4aac72d777744e571ee44ccba4144.jpg";